import { render, staticRenderFns } from "./Accounting.vue?vue&type=template&id=13c04108"
import script from "./Accounting.vue?vue&type=script&setup=true&lang=js"
export * from "./Accounting.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Accounting.vue?vue&type=style&index=0&id=13c04108&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports